// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__E2cZj","wrapper-weather":"Main_wrapper-weather__1b7RP","wrapper-weather-cards":"Main_wrapper-weather-cards__1dPiJ"};